export default __webpack_public_path__ + "static/AD_9459_rgb-e835654c00340493c562ed2e83c3dd17.jpg";